import { DefaultOperatorModel } from '@huggg/react-components';
import dictionary from 'config/dictionary';
import overrides from 'config/postOfficeDictionary.json';
import merge from 'lodash/merge';

export const postOfficeDictionary = merge({}, dictionary, overrides);

// Operator facts live on the theme model (see getThemeModelLoader), so
// components read them through useThemeContext().operator. The helpers below
// exist for code outside the theme provider: redux thunks, class components
// and the pure error helpers.
export const hugggOperator = DefaultOperatorModel;
export const postOfficeOperator = {
  name: 'post-office',
  website: 'https://www.postoffice.co.uk/post-office-payout',
  privacy: 'https://www.postoffice.co.uk/privacy',
  legal:
    '© Post Office Limited, registered in England and Wales Company #02154540. Registered office: 100 Wood Street, London, EC2V 7ER',
  support: 'Please contact the organisation that sent you this link.',
  showHugggSupportLinks: false,
  showHugggPromotions: false,
  exposeApiErrorMessages: false,
  productNoun: 'link',
  siteTitle: 'Post Office',
  faviconPath: '/favicon/post-office',
  maskIcon: null,
  logoSrc: '/favicon/post-office/po-logo.svg',
  // Also skips the GiftWrap unwrap on Landing (welfare treatment).
  isWelfare: true,
};

const dictionaries = { [postOfficeOperator.name]: postOfficeDictionary };

// Keep this precedence aligned with sangria-server. Never classify a known
// non-PO purchase as PO merely because it was opened on the PO domain.
export const isPostOffice = (
  huggg = {},
  hostname = window.location.hostname,
  config = {
    clientIds: [
      process.env.REACT_APP_POST_OFFICE_CLIENT_ID,
      process.env.REACT_APP_POST_OFFICE_API_CLIENT_ID,
      process.env.REACT_APP_POST_OFFICE_WHITE_LABEL_CLIENT_ID,
    ],
    hostnames: (process.env.REACT_APP_POST_OFFICE_LAUNCH_HOSTNAMES || '').split(
      ',',
    ),
  },
) => {
  const clientId = huggg?.purchase_client_id;
  if (clientId !== undefined && clientId !== null && clientId !== '') {
    return config.clientIds.filter(Boolean).includes(clientId);
  }
  return config.hostnames
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean)
    .includes(hostname.toLowerCase());
};

export const getOperator = (huggg, hostname) =>
  isPostOffice(huggg, hostname) ? postOfficeOperator : hugggOperator;

export const brandedDictionary = (operator) =>
  dictionaries[operator?.name] ?? dictionary;
